import axios, { AxiosResponse } from "axios";
import { INV_API } from "../config";

export interface StockValuePoint {
    date: string;
    netValue: number;
}

export const getStockValue = (date: Date, dataCallback: (stockValue: number) => void, errorCallback: (e: Error) => void) => {
    if (!date) {
        // If no date is provided return the current value
        return getStockValue(new Date(), dataCallback, errorCallback);
    }

    axios
        .get(`${INV_API}stockValue?date=${date.toISOString()}`)
        .then((r: AxiosResponse) => {if (dataCallback) dataCallback(r.data.netValue)})        
        .catch ((e) => {if (errorCallback) errorCallback(e)});
}

export const getStockValueRange = (
    startDate: Date, 
    endDate: Date, 
    dataCallback: (data: StockValuePoint[]) => void, 
    errorCallback: (e: Error) => void
) => {
    const startDateString = startDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
    const endDateString = endDate.toISOString().split('T')[0];

    axios
        .get(`${INV_API}stockValueRange?startDate=${startDateString}&endDate=${endDateString}`)
        .then((r: AxiosResponse) => {
            if (dataCallback) dataCallback(r.data);
        })
        .catch((e) => {
            if (errorCallback) errorCallback(e);
        });
}